/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'
import { viewBumbleNameAndProfessionItem } from './viewBumbleNameAndProfessionItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'

export const viewBumbleImageItem = (viewFeedbackTrue, giveFeedbackTrue, imageIndex, datingProfile, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, width) => {
  // console.log('imageIndex ->', imageIndex)
  // console.log('datingProfile.media ->', datingProfile.media[imageIndex])
  // console.log('datingProfile.mediaFeedback ->', datingProfile.mediaFeedback[imageIndex])

  const handleShowSubcaption = () => {
    // console.log('handleShowSubcaption runs index ->', imageIndex)
    setShowSubcaption({ ...showSubcaption, [`mediaItem${imageIndex + 1}`]: !showSubcaption[`mediaItem${imageIndex + 1}`] })
  }

  return (
    <Box
      sx={{
        mt: (imageIndex !== 0 && (viewFeedbackTrue || giveFeedbackTrue)) ? 2 : 0,
        boxShadow: bumbleProfileItemBoxShadow, 
        borderRadius: imageIndex === 0 ? `${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius} 0px 0px` : '0px',
        border: bumbleProfileItemBorderWidth,
        borderColor: bumbleProfileItemBorderColor,
      }}
    >
      {/* Image/Video */}
      <Box
        sx={{
          width: bumbleProfileImageWidth(width),
          height: imageIndex === 0 ? bumbleLeadImageHeight(width) : bumbleImageHeight(width),
          overflow: 'hidden',
        }}
      >
        <Box 
          component={datingProfile.media[imageIndex].mediaType === 'video' ? 'video' : ''}
          onLoadStart={() => setMediaIsLoading({ ...mediaIsLoading, [`mediaItem${imageIndex + 1}`]: true })}
          onLoadedData={() => setMediaIsLoading({ ...mediaIsLoading, [`mediaItem${imageIndex + 1}`]: false })}
          src={datingProfile.media[imageIndex].mediaType === 'video' ? datingProfile.media[imageIndex].mediaItemURL : null} 
          onClick={handleShowSubcaption}
          disabled={!('subcaption' in datingProfile.media[imageIndex]) || datingProfile.media[imageIndex].subcaption.length > 0 }
          autoPlay={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
          playsInline={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
          loop={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
          muted={datingProfile.media[imageIndex].mediaType === 'video' ? true : true}
          sx={{ 
            // mt: 1,
            // width: bumbleProfileImageWidth(width),
            height: imageIndex === 0 ? bumbleLeadImageHeight(width) : bumbleImageHeight(width),
            backgroundImage: `url(${datingProfile.media[imageIndex].mediaItemURL})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            // transform: datingProfile.media[imageIndex].mediaType === 'video' ? 'translate(-25%)' : '', // centers video
            borderRadius: imageIndex === 0 ? `${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius} 0px 0px` : '0px',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-start', 
          }}
        >
          {/* Loading */}
          {mediaIsLoading[`mediaItem${imageIndex + 1}`] 
            &&
            <Box
              sx={{
                width: '30%',
                height: imageIndex === 0 ? bumbleLeadImageHeight(width) : bumbleImageHeight(width),
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              Media is Loading...
            </Box>
          }
          {!mediaIsLoading[`mediaItem${imageIndex + 1}`] && imageIndex === 0 &&
            viewBumbleNameAndProfessionItem(datingProfile, width)
          }
        </Box>

      </Box>

      {viewFeedbackTrue && datingProfile.mediaFeedback[imageIndex].feedback.length > 0 && datingProfile.mediaFeedback[imageIndex].verdict.length > 0 && 
        <Box
          sx={{
            width: bumbleProfileImageWidth(width),
            borderRadius: `0px 0px ${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.mediaFeedback[imageIndex], 'media', datingProfile.type)}

        </Box>
      }
    </Box>
  )
}